import axios from "axios";
import { API_NOTIFICACOES_URL } from "./api";

export default {
  buscarAlertas(
    pagina,
    codigoGrupo,
    idFazenda,
    tamanhoPagina,
    idAlerta,
    token
  ) {
    return axios.get(`${API_NOTIFICACOES_URL}/alerta/listaralertas`, {
      params: { pagina, tamanhoPagina, codigoGrupo, idFazenda, idAlerta },
      responseType: "json",
      headers: {
        Authorization: token,
      },
    });
  },
  marcarAlertaLido(idsAlertas, token) {
    return axios.post(`${API_NOTIFICACOES_URL}/alerta/marcarlido`, idsAlertas, {
      headers: {
        Authorization: token,
      },
    });
  },
  removerAlertas(idsAlertas, token) {
    return axios.post(`${API_NOTIFICACOES_URL}/alerta/remover`, idsAlertas, {
      headers: {
        Authorization: token,
      },
    });
  },
  buscarAlertaExpandido(idAlerta, token) {
    return axios.get(`${API_NOTIFICACOES_URL}/alerta/descricao/${idAlerta}`, {
      headers: {
        Authorization: token,
      },
    });
  },
  buscarAlertaCompleto(idAlerta, token) {
    return axios.get(`${API_NOTIFICACOES_URL}/alerta/completo/${idAlerta}`, {
      headers: {
        Authorization: token,
      },
    });
  },
};
